import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import GridContainer from '@/components/material-ui-kit/components/Grid/GridContainer';
import styles from 'styles/jss/original/components/menus/menuTaxonomyList';
import MenuTaxonomyListItemContainer from '@/containers/menus/MenuTaxonomyListItemContainer';
import { IMenu } from '@/@types/generated/contentful';

// @ts-expect-error
const useStyles = makeStyles(styles);

type ComponentProps = {
  menuList: IMenu[];
};

const MenuTaxonomyList: React.FC<ComponentProps> = ({ menuList }) => {
  const classes = useStyles();
  return (
    <div className={classes.section}>
      <div className={classes.container}>
        {menuList.length === 0 ? (
          <p className={classes.textCenter}>お探しの献立はありません</p>
        ) : (
          <GridContainer>
            {menuList.map((item, index) => {
              return (
                <MenuTaxonomyListItemContainer
                  menu={item}
                  key={`menuTaxonomy-item-${index.toString()}`}
                />
              );
            })}
          </GridContainer>
        )}
      </div>
    </div>
  );
};

export default MenuTaxonomyList;
